export const deData = {
  title: 'Política de Privacidad y Cookies – Danghuan',
  sections: [
    {
      title: 'Introducción',
      content: `
        <p>Esta Política de Privacidad y Cookies explica cómo Danghuan Europe S.L. ('nosotros' o 'Danghuan') recopila, utiliza y protege sus datos personales cuando interactúa con nuestros sitios web y servicios. Esta política se aplica a los residentes del Espacio Económico Europeo (EEE), y cumple con el Reglamento General de Protección de Datos (GDPR).</p>
      `
    },
    {
      title: 'Ámbito de Aplicación',
      content: `
        <p>Esta Política se aplica a:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Visitantes de nuestro sitio web (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Clientes y clientes potenciales</li>
          <li style='margin-bottom: 8px;'>Usuarios de nuestros servicios de recompra y reventa</li>
          <li style='margin-bottom: 8px;'>Representantes de socios comerciales y afiliados de plataformas</li>
        </ul>
      `
    },
    {
      title: 'Datos que Recopilamos',
      content: `
        <p>Dependiendo de su interacción con nosotros, podemos recopilar:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Nombre completo, dirección, correo electrónico y número de teléfono</li>
          <li style='margin-bottom: 8px;'>IBAN, código de sucursal y número de cuenta, PayPal, Revolut u otros datos bancarios</li>
          <li style='margin-bottom: 8px;'>Detalles del dispositivo (modelo, marca, estado, precio, número de serie, IMEI)</li>
          <li style='margin-bottom: 8px;'>Historial de comunicaciones con atención al cliente</li>
          <li style='margin-bottom: 8px;'>Preferencias de marketing e interacciones con campañas</li>
          <li style='margin-bottom: 8px;'>Dirección IP, tipo de navegador, ID de sesión y ubicación</li>
          <li style='margin-bottom: 8px;'>Datos de plataformas como Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>También podemos recibir ciertos datos sobre usted de nuestros socios logísticos o de plataforma (por ejemplo, Shopify, Amazon, Back Market, TEMU) cuando interactúe con sus plataformas en relación con nuestros servicios. Esto incluye datos de pedido, dirección de envío y estado de la transacción.</p>
      `
    },
    {
      title: 'Uso de Datos Personales',
      content: `
        <p>Utilizamos sus datos para:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Procesar pedidos y gestionar la logística (incluidas devoluciones y recompras)</li>
          <li style='margin-bottom: 8px;'>Comunicarnos con usted sobre sus transacciones</li>
          <li style='margin-bottom: 8px;'>Proporcionar atención al cliente y soporte</li>
          <li style='margin-bottom: 8px;'>Enviar comunicaciones de marketing (si usted lo ha consentido)</li>
          <li style='margin-bottom: 8px;'>Cumplir con obligaciones legales (por ejemplo, informes fiscales o controles antifraude)</li>
          <li style='margin-bottom: 8px;'>Mejorar la experiencia del usuario y optimizar nuestras plataformas</li>
        </ul>
      `
    },
    {
      title: 'Cookies',
      content: `
        <p>Utilizamos cookies para mejorar su experiencia de navegación y nuestros servicios. Las cookies pueden recopilar:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Dirección IP y geolocalización</li>
          <li style='margin-bottom: 8px;'>Identificadores del navegador o del dispositivo</li>
          <li style='margin-bottom: 8px;'>Comportamiento de uso (páginas vistas, tiempo en el sitio, clics)</li>
        </ul>
        <p>Tipos de cookies utilizadas:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Cookies estrictamente necesarias</li>
          <li style='margin-bottom: 8px;'>Cookies funcionales</li>
          <li style='margin-bottom: 8px;'>Cookies de rendimiento</li>
          <li style='margin-bottom: 8px;'>Cookies de publicidad</li>
        </ul>
        <p>Puede configurar o revocar sus preferencias de cookies en cualquier momento a través de su navegador o del banner de cookies.</p>
      `
    },
    {
      title: 'Terceros con los que Compartimos Datos',
      content: `
        <p>Compartimos datos con socios de pagos y logística por necesidad contractual; y con proveedores de análisis según su consentimiento de cookies.</p>
        <p>Podemos compartir sus datos con:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Socios de pago: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Proveedores logísticos: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Plataformas: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Proveedores de marketing y análisis: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>Proveedores de TI, consultores, asesores legales</li>
          <li style='margin-bottom: 8px;'>Autoridades gubernamentales si así lo exige la ley</li>
        </ul>
        <p>Los datos pueden transferirse fuera del EEE bajo salvaguardas aprobadas por la UE, como las Cláusulas Contractuales Tipo.</p>
      `
    },
    {
      title: 'Uso de Logotipos de Marcas de Terceros',
      content: `
        <p>Nuestro sitio web muestra nombres y logotipos de marcas como Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google, Insta360 entre otras, únicamente para identificar dispositivos compatibles con nuestros servicios de recompra o reventa. Todas las marcas son propiedad de sus respectivos dueños. Danghuan Europe es un proveedor independiente y no está afiliado ni respaldado por estas marcas, salvo indicación expresa.</p>
        <p>La utilización de estos logotipos es meramente descriptiva. Todas las marcas conservan sus derechos y no existe ninguna asociación implícita con Danghuan.</p>
      `
    },
    {
      title: 'Conservación y Seguridad de los Datos',
      content: `
        <p>Conservamos sus datos solo durante el tiempo necesario para cumplir con los fines anteriores o cuando lo exija la ley. Aplicamos medidas técnicas y organizativas adecuadas para proteger sus datos, incluida la encriptación, el control de acceso y el almacenamiento seguro.</p>
      `
    },
    {
      title: 'Sus Derechos',
      content: `
        <p>Nos comprometemos a responder a todas las solicitudes válidas en el plazo de un mes. Para proteger su privacidad, podemos requerir verificación de identidad antes de procesar su solicitud.</p>
        <p>Usted tiene derecho a:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Acceder y rectificar sus datos</li>
          <li style='margin-bottom: 8px;'>Solicitar su eliminación ('derecho al olvido')</li>
          <li style='margin-bottom: 8px;'>Oponerse o restringir el procesamiento</li>
          <li style='margin-bottom: 8px;'>Retirar su consentimiento en cualquier momento</li>
          <li style='margin-bottom: 8px;'>Solicitar la portabilidad de los datos (cuando sea aplicable)</li>
        </ul>
        <p>Para ejercer estos derechos, contáctenos en: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: 'Actualizaciones de la Política',
      content: `
        <p>Podemos actualizar esta Política para reflejar cambios legales o en nuestras prácticas de tratamiento. La versión más reciente estará siempre disponible en nuestro sitio web.</p>
      `
    },
    {
      title: 'Contacto',
      content: `
        <p>Si tiene preguntas o desea ejercer sus derechos, contáctenos en:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>Correo electrónico:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Sitio web:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>También puede presentar una reclamación ante su autoridad de protección de datos local o ante la Agencia Española de Protección de Datos (AEPD).</p>
      `
    },
    {
      title: 'Anexo – Información Adicional sobre Base Legal y Cookies',
      subsections: [
        {
          title: '1. Base Legal para el Tratamiento de Datos',
          content: `
            <p>La base legal para tratar sus datos personales incluye:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Ejecución de un contrato (por ejemplo, procesamiento de pedidos de recompra, envío de pagos)</li>
              <li style='margin-bottom: 8px;'>Cumplimiento de obligaciones legales (por ejemplo, declaraciones fiscales, verificación de identidad)</li>
              <li style='margin-bottom: 8px;'>Su consentimiento (por ejemplo, comunicaciones de marketing o cookies de terceros)</li>
              <li style='margin-bottom: 8px;'>Intereses legítimos (por ejemplo, prevención del fraude, análisis internos, mejora del servicio)</li>
            </ul>
          `
        },
        {
          title: '2. Medidas de Prevención del Fraude',
          content: `
            <p>Podemos utilizar su información personal (por ejemplo, número de serie del dispositivo, patrón de transacción, geolocalización IP, titularidad del IBAN) para realizar detección de fraude utilizando bases de datos públicas y proveedores de servicios antifraude. Esto se realiza bajo nuestro interés legítimo en prevenir el robo de identidad y el uso indebido de nuestros servicios.</p>
            <p>No tomamos decisiones basadas exclusivamente en el procesamiento automatizado que le afecten significativamente.</p>
          `
        },
        {
          title: '3. Gestión de Datos en Plataformas Externas',
          content: `
            <p>Si compra o vende dispositivos a través de plataformas de terceros como Amazon, Shopify, TEMU o BackMarket, Danghuan Europe puede recibir su información de pedido, dirección de envío y confirmación de pago mediante API cifrada o canal seguro interno, exclusivamente con el fin de completar su transacción y brindar soporte postventa.</p>
          `
        },
        {
          title: '4. Categorías y Detalles de Cookies',
          content: `
            <p>Puede consultar la lista completa de cookies que utilizamos, incluyendo el nombre, proveedor, propósito, duración y tipo (primera o tercera parte), en la tabla incluida a continuación. Esta incluye cookies analíticas de Google Analytics, cookies de remarketing de Meta, y cookies de pago de PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Categoría</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Nombre de la Cookie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Proveedor</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Propósito</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Duración</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Tipo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Estrictamente Necesarias</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Almacena las preferencias de cookies</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 año</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Estrictamente Necesarias</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mantiene el estado de la sesión en todas las páginas</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sesión</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funcionales</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Recuerda la preferencia de idioma</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sesión</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funcionales</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Habilita el soporte por chat en vivo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 meses</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rendimiento</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Recopila estadísticas de uso del sitio web</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 años</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rendimiento</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rastrea el comportamiento del usuario en las sesiones</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 horas</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rendimiento</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mantiene la sesión del usuario en todas las páginas</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 año</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicidad</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Ofrece anuncios personalizados según el comportamiento</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 meses</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicidad</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rastrea las interacciones y conversiones del usuario</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 meses</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicidad</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Rastrea a los usuarios en todos los sitios web para marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 día</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicidad</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Se utiliza para el seguimiento de conversiones</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 meses</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicidad</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifica a los visitantes para campañas de marketing por correo electrónico</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 años</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-Party</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: '5. Promociones, Campañas y Encuestas',
          content: `
            <p>Cuando participe en nuestras promociones, encuestas o concursos, podemos recopilar su nombre, datos de contacto y otra información adicional específica del evento (por ejemplo, edad, ubicación). Estos datos se utilizan exclusivamente para administrar el evento, contactar a los ganadores y mejorar futuras campañas.</p>
          `
        },
        {
          title: '6. Autoridades de Supervisión',
          content: `
            <p>Puede presentar una reclamación ante las siguientes autoridades si considera que se han vulnerado sus derechos de protección de datos:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>En España: Agencia Española de Protección de Datos (AEPD) – <a href="https://www.aepd.es" target="_blank">www.aepd.es</a></li>
              <li style='margin-bottom: 8px;'>En la Unión Europea: puede encontrar la autoridad nacional correspondiente de su país en el sitio del Comité Europeo de Protección de Datos (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};